
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  consents: {
    policies: [],
    offers: [],
  },
  customerThirdParty: {},
  realtorThirdParty: {},
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
